import LegalPage, { LegalSection } from "@/components/LegalPage";

export default function Impressum() {
  return (
    <LegalPage title="Impressum" testid="impressum-page">
      <LegalSection title="Angaben gemäß § 5 DDG">
        <p>
          <strong className="text-[#1A382B]">Kleingartenanlage „Schönwald“ e.V.</strong>
          <br />
          Liliensteinweg 6
          <br />
          13158 Berlin
        </p>
      </LegalSection>

      <LegalSection title="Vertretungsberechtigt">
        <p>
          Der Verein wird jeweils durch zwei Mitglieder des geschäftsführenden Vorstands gemeinsam
          vertreten; unter ihnen muss einer der beiden Vorsitzenden sein.
        </p>
        <p>
          1. Vorsitzende: Katharina Bruck
          <br />
          2. Vorsitzender: Dmitri Topolnizki
        </p>
      </LegalSection>

      <LegalSection title="Kontakt">
        <p>
          E-Mail:{" "}
          <a href="mailto:info@kga-schoenwald.de" className="font-medium text-[#1A382B] underline decoration-[#C85A32]/50 underline-offset-4 hover:text-[#C85A32]" data-testid="impressum-mail-info">
            info@kga-schoenwald.de
          </a>
        </p>
        <p>
          Technische Anliegen zur Website:{" "}
          <a href="mailto:admin@kga-schoenwald.de" className="font-medium text-[#1A382B] underline decoration-[#C85A32]/50 underline-offset-4 hover:text-[#C85A32]" data-testid="impressum-mail-admin">
            admin@kga-schoenwald.de
          </a>
        </p>
      </LegalSection>

      <LegalSection title="Registereintrag">
        <p>
          Eintragung im Vereinsregister.
          <br />
          Registergericht: Amtsgericht Berlin-Charlottenburg
          <br />
          Registernummer: VR 15922 B
        </p>
      </LegalSection>

      <LegalSection title="Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV">
        <p>
          Katharina Bruck, Anschrift wie oben.
        </p>
      </LegalSection>

      <LegalSection title="Hinweis zur Grundstücksverwaltung">
        <p>
          Für die Verwaltung der Grundstücke und die Vergabe von Parzellen ist nicht der Verein,
          sondern das Kirchliche Verwaltungsamt Berlin Mitte Nord (KVA) zuständig:
          KVA Immobilienmanagement, Herr Wittig, Tel. 030 2581 85 226,{" "}
          <a href="mailto:B.Wittig@kva-bmn.de" className="font-medium text-[#1A382B] underline decoration-[#C85A32]/50 underline-offset-4 hover:text-[#C85A32]">
            B.Wittig@kva-bmn.de
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection title="Haftung für Links">
        <p>
          Unsere Website enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
          Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
          oder Betreiber verantwortlich. Zum Zeitpunkt der Verlinkung waren keine Rechtsverstöße
          erkennbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend
          entfernen.
        </p>
      </LegalSection>

      <LegalSection title="Bilderquellen">
        <p>
          Die Fotos in der Galerie sind eigene Aufnahmen aus der Kleingartenanlage „Schönwald“
          (kga-schoenwald.de). Die Porträtfotos der Vorstandsmitglieder wurden uns privat von den
          Abgebildeten zur Verfügung gestellt; das Porträt der 1. Vorstandsvorsitzenden Katharina
          Bruck stammt von <a href="https://www.phildera.net/" target="_blank" rel="noopener noreferrer" className="font-medium text-[#1A382B] underline decoration-[#C85A32]/50 underline-offset-4 hover:text-[#C85A32]" data-testid="impressum-link-phildera"><strong>Phil Dera</strong> (Fotograf, phildera.net)</a>. Das Titelbild im Kopfbereich stammt von Unsplash
          (unsplash.com, Unsplash-Lizenz).
        </p>
      </LegalSection>

      <LegalSection title="Wetterradar und Wetterdaten">
        <p>
          Diese Website enthält ein Wetterradar mit Niederschlagsdaten und Vorhersage. Dafür nutzen
          wir folgende Quellen:
        </p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>
            Niederschlagsradar (Analyse und Vorhersage): Radarkomposit RV des Deutschen
            Wetterdienstes (DWD), bereitgestellt über den DWD-Geodienst (maps.dwd.de)
          </li>
          <li>Amtliche Wetterwarnungen: Deutscher Wetterdienst (dwd.de)</li>
          <li>Stündliche Regenprognose: Open-Meteo (open-meteo.com, CC BY 4.0)</li>
          <li>Kartendarstellung: © OpenStreetMap-Mitwirkende (openstreetmap.org)</li>
        </ul>
        <p>
          Die Wetterdaten dienen der Information der Pächter; es wird keine Gewähr für die
          Richtigkeit und Vollständigkeit der Vorhersagen übernommen.
        </p>
      </LegalSection>

      <LegalSection title="Urheberrecht">
        <p>
          Die auf dieser Website veröffentlichten Inhalte und Fotos unterliegen dem deutschen
          Urheberrecht. Jede Verwertung außerhalb der Grenzen des Urheberrechts bedarf der
          vorherigen schriftlichen Zustimmung des Vereins.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
